import merge from "lodash/merge";
export const mergeSlotProps = (baseSlotsProps, overridingSlotsProps) => merge({}, baseSlotsProps, overridingSlotsProps);
export function slotsWithDefault(req, slots) {
    return { ...req, ...slots };
}
//# sourceMappingURL=slots.js.map